import React, {useEffect, useRef} from 'react';
import {Button, DatePicker, Descriptions, Form, Input, InputNumber, Modal, Select, Spin, Table} from 'antd';
import {updatecwsrdj, getcwsrdj} from "../../lib/api_cw_srdj";
import {getDetail} from "../../lib/api_cw_zcfkd";
import moment from "moment";

/**
 * 付款单弹窗
 * @param onCancel
 * @param onOk
 * @returns {JSX.Element}
 * @constructor
 */
const ZcfkdEditModal = ({id, onCancel, onOk}) => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState({});
    const printContentRef = useRef(null);

    const fetchData = () => {
        setLoading(true)
        getDetail(id)
            .then(res => {
                if (res.code === 0) {
                    setData(res.data);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(fetchData, [id]);

    const handleOk = () => {
        onOk && onOk();
    }
    const handleCancel = () => {
        onCancel && onCancel();
    }

    const handlePrint = () => {
        if (printContentRef.current) {
            const printContent = printContentRef.current.innerHTML;
            const printWindow = window.open('', '_blank');
            printWindow.document.write(`
      <html>
        <head>
          <title>打印内容</title>
          <style>
            /* 打印样式 */
            @media print {
              body {
                font-family: Arial, sans-serif;
                padding: 20px;
              }
              .print-container {
                max-width: 800px;
                margin: 0 auto;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-container">${printContent}</div>
        </body>
      </html>
    `);
            printWindow.document.close();
            printWindow.focus();
            // 延迟执行打印，确保内容已加载
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 500);
        }
    }

    return (
        <Modal
            title="付款单详情"
            open={true}
            onCancel={handleCancel}
            onOk={handleOk}
            confirmLoading={loading}
            width={1000}
            footer={false}
        >
            {/*打印按钮*/}
            <Button type="primary" onClick={handlePrint}>打印</Button>
            <Spin spinning={loading}>
                <div ref={printContentRef}>
                    <Descriptions title="付款单详情" column={1}>
                        <Descriptions.Item label="创建日期">{moment(data.cjsj).format('YYYY-MM-DD')}</Descriptions.Item>
                        <Descriptions.Item label="付款金额">{data.hjje}</Descriptions.Item>
                        <Descriptions.Item label="笔数">{data.bishu}</Descriptions.Item>
                    </Descriptions>
                    <Table
                        columns={[
                            {
                                title: '审批编号',
                                dataIndex: 'sp_no',
                                key: 'sp_no',
                                width: 150,
                                fixed: 'left',
                            },
                            {
                                title: '来源',
                                dataIndex: 'ly',
                                key: 'ly',
                                width: 100,
                                fixed: 'left',
                            },
                            {
                                title: '提交日期',
                                dataIndex: 'date',
                                key: 'date',
                                width: 130,
                            },
                            {
                                title: '金额',
                                dataIndex: 'je',
                                key: 'je',
                                width: 130,
                            },
                            {
                                title: '备注',
                                dataIndex: 'bz',
                                key: 'bz',
                            },
                        ]}
                        dataSource={data.zcdjs}
                        pagination={false}
                    />
                </div>
            </Spin>
        </Modal>
    )
}

export default ZcfkdEditModal;
